import { get, post } from './http';
import { fetchSSE } from './sse';

const baseUrl = process.env.VUE_APP_BASE_URL;

// 获取完整大纲
const getOutline = (params) => get(`${baseUrl}/outline/get/json`, params);
// 保存大纲
const saveOutline = (data) => post(`${baseUrl}/outline/save/json`, data);
// 主题生成大纲
const outlineByTopic = (data, signal, cb) => fetchSSE(`${baseUrl}/outline/create/sse/byTopic`, data, signal, cb);
// 文本生成大纲
const outlineByContent = (data, signal, cb) => fetchSSE(`${baseUrl}/outline/create/sse/byContext`, data, signal, cb);
// 文档生成大纲
const outlineByDocument = (data, signal, cb) => fetchSSE(`${baseUrl}/outline/create/sse/byDocument`, data, signal, cb);
// 保存md格式的大纲
const saveMarkdown = (data) => post(`${baseUrl}/outline/save/markdown`, data);
// 重新生成大纲
const createOutline = (params, signal, cb) => fetchSSE(`${baseUrl}/outline/recreate/sse`, params, signal, cb);
// 获取md格式的大纲
const getMarkdown = (params) => get(`${baseUrl}/outline/get/markdown`, params);
// 获取用户剩余重建大纲次数
const getRecreateRemain = (params) => get(`${baseUrl}/userRight/remain/recreateOutline`, params);
// 将游客模式下生成的大纲同步到登录账号
const syncOutline = (data) => post(`${baseUrl}/outline/syncFromGuest`, data);

export default {
  getOutline,
  saveOutline,
  outlineByTopic,
  outlineByContent,
  outlineByDocument,
  saveMarkdown,
  createOutline,
  getMarkdown,
  getRecreateRemain,
  syncOutline,
}
